import styled from 'styled-components';

import media from '../../styles/media.style';
import { BG_GRAY, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

export const Wrapper = styled.section`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 0 16px;
  margin: 0 auto;

  ${media.tabletL`
    padding: 0;
  `};
`;
export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  margin: 0 0 60px;
  letter-spacing: 0.1em;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletP`
    margin-top: 22px;
    margin-bottom: 90px;
  `};
`;

export const ProductsWrapper = styled.div``;
export const Product = styled.div`
  display: flex;
  margin-bottom: 30px;
  flex-direction: column;

  ${media.tabletP`
    flex-direction: row;
    padding: 0;
  `};
`;

export const ImageWrapper = styled.div`
  flex: 1;
  height: 190px;

  ${media.tabletP`
    margin-right: 50px;
    height: auto;
  `};
`;

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 30px 0;
  align-items: center;

  a {
    display: block;
    margin-top: 30px;
    font-weight: 800;
    font-size: 13px;
    text-decoration: underline;
    text-transform: uppercase;
  }
`;

export const ProductTitle = styled.h3``;
export const ProductDescription = styled.div`
  h1,
  h2 {
    font-size: 20px;
    font-style: italic;
    font-weight: 600;
  }
`;

export const TreatmentType = styled.h2`
  font-size: 32px;
  text-transform: uppercase;
  margin-bottom: 20px;
  margin-top: 0;
`;

export const InfoWrapper = styled.div`
  max-width: 450px;
`;

export const ProductConditions = styled.ul`
  li {
    margin-left: 15px;
  }
`;

export const SalonSolutionsWrapper = ProductsWrapper.extend`
  margin: 33px 0;

  ${media.tabletP`
    margin: 100px 0;
  `};
`;

export const PlaceholderWrapper = styled.div`
  height: 190px;

  ${media.tabletP`
    height: 350px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/TreatmentRecommendations/TreatmentRecommendations.style.js